import { render, staticRenderFns } from "./LanguageHeader.vue?vue&type=template&id=f1437b6c&scoped=true"
import script from "./LanguageHeader.vue?vue&type=script&lang=ts"
export * from "./LanguageHeader.vue?vue&type=script&lang=ts"
import style0 from "./LanguageHeader.vue?vue&type=style&index=0&id=f1437b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1437b6c",
  null
  
)

export default component.exports